import { isAfter, subDays } from "date-fns";

import { SURVEY_INTERVAL_DAYS, SURVEYS_KEY } from "../consts";

type UserState = {
  lastSeen?: string;
  seenSurveys?: {
    surveyId: string;
    lastSeen: string;
  }[];
};

type State = {
  [userId: string]: UserState;
};

export function hasSurveyBeenSeen(surveyId: string, userId: string) {
  const { seenSurveys } = getStateForUser(userId);
  return !!seenSurveys?.find(survey => survey.surveyId === surveyId);
}

export function hasAnySurveyBeenSeenRecently(userId: string) {
  const { lastSeen } = getStateForUser(userId);

  return (
    !!lastSeen &&
    isAfter(new Date(lastSeen), subDays(new Date(), SURVEY_INTERVAL_DAYS))
  );
}

export function setSurveySeen(surveyId: string, userId: string) {
  const { seenSurveys = [] } = getStateForUser(userId);
  const lastSeen = new Date().toISOString();

  setStateForUser(userId, {
    seenSurveys: [...seenSurveys, { surveyId, lastSeen }],
    lastSeen
  });
}

function getStateForUser(userId: string): UserState {
  return getState()[userId] || {};
}

function setStateForUser(userId: string, state: UserState) {
  const existingState = getState();

  setState({
    ...existingState,
    [userId]: state
  });
}

function getState(): State {
  try {
    const item = window.localStorage.getItem(SURVEYS_KEY);
    return JSON.parse(item!) || {};
  } catch (err) {
    console.error(`Unable to get ${SURVEYS_KEY} from local storage`);
    return {};
  }
}

function setState(state: State) {
  try {
    window.localStorage.setItem(SURVEYS_KEY, JSON.stringify(state));
  } catch (err) {
    console.log(`Unable to set ${SURVEYS_KEY} in local storage`, err);
  }
}
